<template>

  <section class="book bg-light" style="height: 100%;">
    <div class="container-fluid">
      <div class="row g-3 g-md-4 g-lg-5">
        <div class="col-xxl-6 col-lg-6">

          <div class="d-flex align-items-center gap-3 gap-md-4 mb-3 mb-md-4 mb-lg-5">
            <button class="btn btn-default btn-icon btn-icon-sm rounded-circle" type="button" @click="$router.go(-1)">
              <i class="fas fa-arrow-left"></i>
            </button>
            <h5 class="fw-bold mb-0">Confirm and pay</h5>
          </div>

          <div class="card mb-3">
            <div class="row g-0">
              <div class="col-md-4">
                <div class="carousel-inner">
                  <div
                    class="carousel-item payment-image-preview active"
                    v-for="imgs of !unit_image
                      ? unit_image
                      : unit_image.split(',')"
                  >
                    <img
                      :src="url + imgs"
                      class="d-block img-fluid"
                      alt="..."
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-8">
                <div class="card-body">
                  <h4 class="card-text">{{ unit_number }}</h4>
                  <h6 class="card-title">{{ project_name }}</h6>
                  <p class="card-text text-muted">
                    {{ project_category + ", " + place_type }}
                  </p>
                  <!-- <p class="card-text"><small class="text-muted">3 mins ago</small></p> -->
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="mb-3 mb-md-4">Your booking is covered by RentalCover</div>
          <h6 class="text-dark fw-bold mb-3 mb-md-4">Price Details</h6>
          <div class="d-flex flex-column gap-2">
            <div class="d-flex justify-content-between gap-4 w-100">
              <span
                >₱{{
                  formatCurrency(rate_amount) +
                  " x" +
                  intervalToDurationDate(date_from, date_to)
                }}
                {{
                  intervalToDurationDate(date_from, date_to) > 1
                    ? "nights"
                    : "night"
                }}
              </span>
              <span class="text-dark"
                >₱{{ formatCurrency(total_rate_amount) }}</span
              >
            </div>
            <!-- <div class="d-flex justify-content-between gap-4 w-100">
      <span>Cleaning fee</span>
      <span class="text-dark">₱1,000.00</span>
    </div>
    <div class="d-flex justify-content-between gap-4 w-100">
      <span>Service fee</span>
      <span class="text-dark">₱1,000.00</span>
    </div> -->
            <div
              class="d-flex justify-content-between gap-4 w-100"
              v-if="payment_policy.recordID != null"
            >
              <span>{{ payment_policy.policyName }}</span>
              <span class="text-dark"
                >₱ {{ formatCurrency(grand_total) }}</span
              >
            </div>
            <div
              class="d-flex justify-content-between gap-4 w-100"
              v-if="payment_policy.recordID != null"
            >
              <span>Balance</span>
              <span class="text-dark"
                >₱ {{ formatCurrency(remaining_balance) }}</span
              >
            </div>
          </div>
          <div class="border-top my-3" style="height: 1px"></div>
          <div class="d-flex justify-content-between gap-4 w-100">
            <span class="text-dark"><b>Amount to settle</b></span>
            <span class="text-dark fw-bold"
              >₱ {{ formatCurrency(grand_total) }}</span
            >
          </div>
        </div>

        <div class="col-xxl-6 col-lg-6 d-flex align-items-end flex-column">
          <div class="card border bg-white">
            <div class="card-body border-bottom p-4 p-lg-5">
              <div class="mb-0">
                <div class="mb-3" v-if="userName != null">
                  <h6 class="text-dark fw-bold mb-1">Customer Name</h6>
                  <div class="d-flex justify-content-between gap-4">
                    <span>{{ userName }}</span>
                  </div>
                </div>

                <div class="mb-3" v-if="userEmail != null">
                  <h6 class="text-dark fw-bold mb-1">Email</h6>
                  <div class="d-flex justify-content-between gap-4">
                    <span>{{ userEmail }}</span>
                  </div>
                </div>

                <div class="mb-3">
                  <h6 class="text-dark fw-bold mb-1">Dates</h6>
                  <div class="d-flex justify-content-between gap-4">
                    <span>{{
                      dateFormat(date_from) + " — " + dateFormat(date_to)
                    }}</span>
                    <!-- <a href="#">Edit</a> -->
                  </div>
                </div>
                <div class="mb-3">
                  <h6 class="text-dark fw-bold mb-1">Guests</h6>
                  <div class="d-flex justify-content-between gap-4">
                    <span
                      >{{ guest_count }}
                      {{ guest_count < 2 ? "guest" : "guests" }}</span
                    >
                    <!-- <a
                      href="#"
                      role="button"
                      data-bs-toggle="modal"
                      data-bs-target="#editGuestModal"
                      >Edit</a
                    >-->
                  </div>
                </div>
                <div class="mb-3">
                  <h6 class="text-dark fw-bold mb-2">Payment Policy*</h6>
                  <div class="row g-4 g-md-2">
                    <div v-for="policy in payment_policies.data">
                      <div class="col-12">
                        <label
                          class="form-check-label"
                          :for="'flexRadioDefault' + policy.recordID"
                        >
                          <input
                            ref="payment_policy"
                            @change="PolicyValue"
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            v-model="payment_policy"
                            :id="'flexRadioDefault' + policy.recordID"
                            :value="policy"
                            :checked="
                              payment_policy.policyValue == 100 ? true : false
                            "
                          /><span> {{ policy.policyName }}</span></label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="p-lg-4">
              <Authentication />
            </div> -->

            <div class="card-body p-4 p-lg-5">
              <form @submit.prevent="payment()" id="payment_form">
                <div class="small text-muted mb-4">
                  By clicking the "confirm and pay" button, you agree with the
                  <a href="#">privacy policy</a> and
                  <a href="#">terms & conditions</a> of rentease.
                </div>
                <div class="d-flex align-items-end flex-column">
                  <button type="submit" class="btn btn-primary">
                    Proceed to payment
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div
      class="modal fade"
      id="editDatesModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="editDatesModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header p-4">
            <h5 class="fw-bold mb-0" id="editDatesModalLabel">Edit guest</h5>
            <a
              href="#"
              class="btn btn-default btn-icon btn-icon-sm rounded-circle"
              role="button"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="fas fa-times"></i>
            </a>
          </div>
          <div class="modal-body p-4"></div>
          <div class="modal-footer p-4"></div>
        </div>
      </div>
    </div> -->

    <div
      class="modal fade"
      id="editGuestModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="editGuestModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header p-4">
            <h5 class="fw-bold mb-0" id="editGuestModalLabel">Edit guest</h5>
          </div>
          <div class="modal-body p-4">
            <div class="d-flex flex-column gap-3">
              <div
                class="d-flex justify-content-between align-items-end gap-3 gap-lg-5"
              >
                <div class="d-flex flex-column">
                  <span class="fw-bold">Adults</span>
                  <span class="small text-muted" style="white-space: nowrap"
                    >Ages 13 or above</span
                  >
                </div>
                <div class="d-inline-block">
                  <div class="d-flex flex-nowrap">
                    <button
                      class="btn btn-default btn-icon btn-icon-xs"
                      type="button"
                      :disabled="adult_count <= 1"
                      @click="subtractAdultCount(1)"
                    >
                      <i class="fas fa-minus fa-sm"></i>
                    </button>
                    <input
                      type="text"
                      v-model="adult_count"
                      class="form-control form-control-xs bg-white text-center"
                      style="
                        width: 35px;
                        background-color: transparent !important;
                        border-color: transparent !important;
                        box-shadow: none !important;
                      "
                      readonly
                    />
                    <button
                      class="btn btn-default btn-icon btn-icon-xs"
                      type="button"
                      :disabled="max_adult <= adult_count"
                      @click="addAdultCount(1)"
                    >
                      <i class="fas fa-plus fa-sm"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="d-flex justify-content-between align-items-end gap-3 gap-lg-5"
              >
                <div class="d-flex flex-column">
                  <span class="fw-bold">Children</span>
                  <span class="small text-muted" style="white-space: nowrap"
                    >Ages 2-12</span
                  >
                </div>
                <div class="d-inline-block">
                  <div class="d-flex flex-nowrap">
                    <button
                      class="btn btn-default btn-icon btn-icon-xs"
                      type="button"
                      :disabled="child_count <= 0"
                      @click="subtractChildCount(1)"
                    >
                      <i class="fas fa-minus fa-sm"></i>
                    </button>
                    <input
                      type="text"
                      value="0"
                      class="form-control form-control-xs bg-white text-center"
                      style="
                        width: 35px;
                        background-color: transparent !important;
                        border-color: transparent !important;
                        box-shadow: none !important;
                      "
                      readonly
                      v-model="child_count"
                    />
                    <button
                      class="btn btn-default btn-icon btn-icon-xs"
                      type="button"
                      :disabled="max_child <= child_count"
                      @click="addChildCount(1)"
                    >
                      <i class="fas fa-plus fa-sm"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex gap-2 p-4">
            <button
              type="button"
              class="btn btn-transparent btn-sm"
              data-bs-dismiss="modal"
              @click="resetGuestCount()"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="
                changeQueryString();
                addTotalCount();
              "
              :disabled="
                parseInt($route.query.adult == null ? 0 : $route.query.adult) ==
                  adult_count &&
                ($route.query.child == null ? 0 : $route.query.child) ==
                  child_count
                  ? true
                  : false
              "
              data-bs-dismiss="modal"
              class="btn btn-primary btn-sm"
            >
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import formatDate from "@/helpers/formatDate.js";
import Authentication from "@/components/Authentication.vue";
import { format, intervalToDuration, parseISO } from "date-fns";
import { provide } from "vue";

export default {
  name: "Book",
  components: {
    Authentication,
  },
  data: () => ({
    url: process.env.VUE_APP_API_URL,
    how_to_pay: "",
    arr_unit_details: [],
    payment_option: 1,
    project_name: "",
    project_category: "",
    place_type: "",
    first_image: "",
    rate_amount: 0,
    total_rate_amount: 0,
    grand_total: 0,
    date_from: "",
    date_to: "",
    guest_count: 0,
    adult_count: 0,
    child_count: 0,
    max_adult: 0,
    max_child: 0,
    rate_code: "",
    room_code: "",
    unit_number: "",
    unit_image: "",
    userEmail: null,
    userName: null,
    payment_policy: "",
    payment_policies: [],
    remaining_balance: 0,
  }),
  mounted() {
    this.getUnitDetails();
    this.getPaymentPolicies();
    this.payment_policy = 1;
    this.userEmail = localStorage.getItem("userEmail");
    this.userName = localStorage.getItem("userName");
    this.date_from = this.$route.query.check_in;
    this.date_to = this.$route.query.check_out;
    this.adult_count = parseInt(
      this.$route.query.adult != null ? this.$route.query.adult : 0
    );
    this.child_count = parseInt(
      this.$route.query.child != null ? this.$route.query.child : 0
    );
    this.guest_count =
      parseInt(this.$route.query.adult != null ? this.$route.query.adult : 0) +
      parseInt(this.$route.query.child != null ? this.$route.query.child : 0);
  },
  methods: {
    PolicyValue() {
      var partial = this.total_rate_amount;
      var percentage = 100 / this.payment_policy.policyValue;

      this.grand_total = partial / percentage;
      this.remaining_balance = this.total_rate_amount - this.grand_total;
    },
    async getPaymentPolicies() {
      const res = await axios.get(this.url + "/api/paymentpolicy?", {
        params: {
          recordID: 0,
          searchquery: "",
        },
      });
      this.payment_policies = res.data;
    },
    resetGuestCount() {
      $(function () {
        $("#modal").modal("toggle");
      });

      this.adult_count = parseInt(
        this.$route.query.adult != null ? this.$route.query.adult : 0
      );
      this.child_count = parseInt(
        this.$route.query.child != null ? this.$route.query.child : 0
      );

      this.addTotalCount();
      this.changeQueryString();
    },
    intervalToDurationDate(dateFrom, dateTo) {
      if (dateFrom !== "" && dateTo !== "") {
        var startDate = new Date(
          format(new Date(parseISO(dateFrom)), "MM/dd/yyyy")
        );
        var endDate = new Date(
          format(new Date(parseISO(dateTo)), "MM/dd/yyyy")
        );
        var diff_in_time = endDate.getTime() - startDate.getTime();
        var diff_in_days = diff_in_time / (1000 * 3600 * 24);

        return diff_in_days;
      }
    },
    dateFormat(date) {
      return formatDate(date, "date");
    },
    addTotalCount() {
      this.guest_count = this.adult_count + this.child_count;
    },
    addAdultCount: function (inc) {
      if (this.max_adult > this.adult_count) {
        this.adult_count += inc;
      }
    },
    subtractAdultCount: function (dec) {
      if (this.adult_count > 1) {
        this.adult_count -= dec;
      }
    },
    addChildCount: function (inc) {
      if (this.max_child > this.child_count) {
        this.child_count += inc;
      }
    },
    subtractChildCount: function (dec) {
      if (this.child_count > 0) {
        this.child_count -= dec;
      }
    },
    redirectToRoomDetails(unit_code) {
      this.$router.push({
        name: "Room",
        params: { str_unit_code: unit_code },
      });
    },
    formatCurrency(val) {
      if (val !== null) {
        return val.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    changeQueryString() {
      this.$router.replace({
        query: {
          check_in: this.date_from || undefined,
          check_out: this.date_to || undefined,
          adult: this.adult_count || undefined,
          child: this.child_count || undefined,
        },
      });
    },
    async getUnitDetails() {
      const res = await axios.get(this.url + "/api/units/unit", {
        params: {
          strUnitCode: this.$route.params.str_unit_code,
        },
      });
      this.arr_unit_details = JSON.parse(res.data);

      this.project_name = this.arr_unit_details[0].ProjectName;
      this.project_category = this.arr_unit_details[0].ProjectCategory;
      this.place_type = this.arr_unit_details[0].PlaceType;
      this.rate_amount = this.arr_unit_details[0].RateAmount;
      this.max_adult = this.arr_unit_details[0].MaxAdult;
      this.max_child = this.arr_unit_details[0].MaxChild;
      this.room_code = this.arr_unit_details[0].UnitCode;
      this.unit_number = this.arr_unit_details[0].UnitNumber;
      this.rate_code = this.arr_unit_details[0].RateCode;
      this.unit_image = this.arr_unit_details[0].UnitImages;

      var rateAmount = this.rate_amount.replace(",", "");
      var dateInterval = this.intervalToDurationDate(
        this.date_from,
        this.date_to
      );
      this.total_rate_amount = rateAmount * dateInterval;
      this.grand_total = this.total_rate_amount;

      var path = this.url + "/assets/images/";

      this.first_image = path + this.arr_unit_details[0].UnitImage;
    },
    async payment() {
      this.userEmail = localStorage.getItem("userEmail");
      if (this.userEmail == null) {
        $(function () {
          $("#registrationModal").modal("toggle");
        });
      } else {
        var form = document.getElementById("payment_form");
        var elements = form.elements;

        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].disabled = true;
        }

        const formData = new FormData();
        formData.append("ProjectCode", this.arr_unit_details[0].ProjectCode);
        formData.append("RoomCode", this.room_code);
        formData.append("DateArrival", this.date_from);
        formData.append("DateCheckout", this.date_to);
        formData.append("AdultNumber", this.adult_count);
        formData.append("ChildNumber", this.child_count);
        formData.append("RateCode", this.rate_code);
        formData.append("Email", this.userEmail);
        formData.append("RateAmount", this.arr_unit_details[0].RateAmount);
        formData.append("DiscountType", 0);
        formData.append("DiscountAmount", 0);
        formData.append("PaymentType", 0);
        formData.append("PaymentAmount", this.grand_total);
        formData.append("PaymentPolicyID", this.payment_policy.recordID);

        try {
          const res = await axios.post(this.url + "/api/reservation", formData);
          if (res.data != null) {
            // window.open(res.data.data, "_blank");
            window.location.href = res.data.data;
          }
        } finally {
          for (var i = 0, len = elements.length; i < len; ++i) {
            elements[i].disabled = false;
          }
        }
      }
    },
  },
};
</script>
